/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { NetworkType } from '@gamestream/ragnarok';
import { Types } from 'bridge-commands/types';
import { NetworkTypeConstants } from 'crimson/lib/system-info-service/system-info.models';

export enum BrowserDbNames {
    Shared = 'sharedStore',
    Webclient = 'webclientStore',
    Config = 'configStore'
}
export interface BrowserDbUpdateMessage {
    source: string;
    path: string[];
    data?: any;
    operationType: Types.Common.Sharedstorage.OperationType;
}

/**
 * A map to transform Ragnarok's `NetworkType` to SystemInfo's `NetworkTypeConstants` plain string.
 */
export const NetworkTypeToNetworkTypeConstantMap = {
    [NetworkType.ETHERNET]: NetworkTypeConstants.Ethernet,
    [NetworkType.WIFI]: NetworkTypeConstants.WiFiUnknown,
    [NetworkType.WIFI_2_4]: NetworkTypeConstants.WiFi2_4,
    [NetworkType.WIFI_5_0]: NetworkTypeConstants.WiFi5_0,
    [NetworkType.MOBILE]: NetworkTypeConstants.Mobile,
    [NetworkType.MOBILE_2G]: NetworkTypeConstants.Mobile_2G,
    [NetworkType.MOBILE_3G]: NetworkTypeConstants.Mobile_3G,
    [NetworkType.MOBILE_4G]: NetworkTypeConstants.Mobile_4G,
    [NetworkType.MOBILE_5G]: NetworkTypeConstants.Mobile_5G,
    [NetworkType.OTHER]: NetworkTypeConstants.Other,
    [NetworkType.WIMAX]: NetworkTypeConstants.Wimax,
    [NetworkType.BLUETOOTH]: NetworkTypeConstants.Bluetooth,
    [NetworkType.UNKNOWN]: NetworkTypeConstants.Unknown
} as const;
